import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import CountUp from "react-countup";

const CircleChart = ({ data = [], Title, Total, TotalTitle }) => {
  const formattedData = data.map((item) => ({
    ...item,
    value: Number(item.value),
  }));

  return (
    <div className="light-bg-L h-full w-full p-4 flex flex-col justify-between">
      {/* Chart Title */}
      <h2 className="head-2 dark-H text-center mb-4">{Title}</h2>

      {/* Chart Container */}
      <div className="relative w-full flex justify-center items-center" style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={formattedData}
              dataKey="value"
              startAngle={70}
              endAngle={430}
              innerRadius="70%"
              outerRadius="90%"
              paddingAngle={0}
              cornerRadius={5}
            >
              {formattedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}`} />
          </PieChart>
        </ResponsiveContainer>

        {/* Center Text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <div className="body-N dark-M">{TotalTitle}</div>
          <div className="number-Text dark-H">
            {typeof Total === "number" ? (
              <CountUp end={Total} separator="," duration={2} />
            ) : (
              Total
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircleChart;
